var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "br-pagebody" },
      [
        _vm.initialized
          ? _c("div", { staticClass: "br-section-wrapper" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("div", { staticClass: "form-layout form-layout-4" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("div", {
                            staticClass: "form-control-label col-12 col-md-4 "
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-control-label col-12 col-md-8 text-info"
                            },
                            [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(_vm.$t("totpexplanationtext")) +
                                  "\n                                    "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-control-label col-12 col-md-4"
                            },
                            [
                              _c("label", { staticClass: "mg-t-7" }, [
                                _vm._v(_vm._s(_vm.$tc("scanimage")) + ":")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-control-label col-12 col-md-8"
                            },
                            [_c("img", { attrs: { src: _vm.record.imageUrl } })]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-control-label col-12 col-md-4"
                            },
                            [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(_vm.$t("manualsettingcode")) +
                                  ":\n                                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-control-label col-12 col-md-8"
                            },
                            [
                              _c("label", { staticClass: "mg-5" }, [
                                _vm._v(_vm._s(_vm.record.secretKey))
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass: "form-control-label col-12 col-md-4"
                            },
                            [
                              _c("label", { staticClass: "mg-t-7" }, [
                                _vm._v(
                                  _vm._s(_vm.$tc("verificationcode")) + ":"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-control-label col-12 col-md-8"
                            },
                            [
                              _c("inputtext", {
                                class:
                                  _vm.record.code == null ||
                                  _vm.record.code.length == 0
                                    ? "border border-danger"
                                    : "",
                                attrs: {
                                  name: "code",
                                  placeholder: _vm.$t("verificationcode")
                                },
                                on: { keyupenter: _vm.saveChanges },
                                model: {
                                  value: _vm.record.code,
                                  callback: function($$v) {
                                    _vm.$set(_vm.record, "code", $$v)
                                  },
                                  expression: "record.code"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mg-t-20" }, [
                          _c("div", {
                            staticClass: "form-control-label col-12 col-md-4"
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "form-control-label col-12 col-md-8"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-primary tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-medium",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showTotpHelp()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                            " +
                                      _vm._s(_vm.$t("totpexplanation")) +
                                      "\n                                        "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-primary mg-10 tx-11 tx-uppercase pd-y-12 pd-x-25 tx-mont tx-medium",
                                  attrs: { type: "submit" },
                                  on: { click: _vm.saveChanges }
                                },
                                [_vm._v(_vm._s(_vm.$t("actions.save")))]
                              )
                            ]
                          )
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          : _c("spinner")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }